import React, { useEffect, useRef, useState } from 'react'
import {
  Box,
  Button,
  DataTable,
  Heading,
  Link,
  Select,
  StackView,
} from '@planningcenter/tapestry-react'
import { ThemeProvider } from '~/components/ThemeProvider'

export default function VersionAuditing({
  appVersionOptions,
  auditing,
  columns,
  data,
}) {
  const firstUpdate = useRef(true)
  const { pathname, origin, search } = window.location
  const urlParams = new URLSearchParams(search)
  const [selectedApp, setSelectedApp] = useState(urlParams.get('app'))
  const selectedVersion = urlParams.get('version')
  const appOptions = appVersionOptions.map(({ label, value }) => ({
    label,
    value,
  }))
  const versionOptions = (
    appVersionOptions.find((option) => option.value === selectedApp) || {
      versions: [],
    }
  ).versions

  function handleRefresh(app, version) {
    var searchParams = new URLSearchParams(search)
    searchParams.set('app', app)
    searchParams.set('version', version)
    window.location.search = searchParams.toString()
  }

  function handleAppChange({ value }) {
    setSelectedApp(value)
  }

  function handleVersionChange({ value }) {
    handleRefresh(selectedApp, value)
  }

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }

    if (versionOptions.map((v) => v.value).includes(selectedVersion)) {
      handleRefresh(selectedApp, selectedVersion)
    }
  }, [selectedApp])

  return (
    <ThemeProvider>
      <StackView>
        <Link to="/staff">Staff Resources</Link>
        <StackView
          alignment="center"
          axis="horizontal"
          distribution="space-between"
          marginVertical={2}
        >
          <StackView alignment="center" axis="horizontal" spacing={2}>
            <Heading level={2}>{auditing} for</Heading>
            <Select
              emptyValue="Select App"
              name="app"
              onChange={handleAppChange}
              options={appOptions}
              value={selectedApp}
            />
            <Select
              disabled={!selectedApp}
              emptyValue="Select Version"
              name="version"
              onChange={handleVersionChange}
              options={versionOptions}
              value={selectedVersion}
            />
            <Heading level={2}>({data.length})</Heading>
          </StackView>
          <Button
            href={`${origin}${pathname}.csv${search}`}
            icon={{ name: 'general.share' }}
            title="Export CSV"
            tooltip="Export CSV"
            theme="interaction"
            variant="outline"
          />
        </StackView>
        <DataTable
          columns={columns}
          data={data}
          empty={
            <Box color="grey-8">
              {!selectedApp
                ? 'Select an app and a version!'
                : !selectedVersion
                ? 'Select a version!'
                : `No ${auditing} found 😞`}
            </Box>
          }
        />
      </StackView>
    </ThemeProvider>
  )
}
